import { Link } from 'react-router-dom'

const PRODUCT = 'Manabi'

export default function Terminos() {
  return (
    <div style={{
      minHeight: '100vh', background: '#0a0a0f', padding: '48px 24px',
      fontFamily: '-apple-system,BlinkMacSystemFont,"SF Pro Display",sans-serif', color: 'rgba(255,255,255,0.85)',
    }}>
      <div style={{ maxWidth: 680, margin: '0 auto' }}>
        <Link to="/" style={{ fontSize: 14, color: '#ff3b30', textDecoration: 'none', display: 'inline-block', marginBottom: 32 }}>
          ← Volver al inicio
        </Link>

        <h1 style={{ fontSize: 28, fontWeight: 800, color: '#fff', marginBottom: 8 }}>Términos y Condiciones</h1>
        <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.3)', marginBottom: 40 }}>Última actualización: mayo 2026</p>

        {[
          {
            title: '1. Uso de tus datos',
            body: `Tus datos de salud (frecuencia cardíaca, variabilidad de la frecuencia cardíaca, etc.) son almacenados de forma segura y son estrictamente privados. ${PRODUCT} no comparte ningún dato personal ni de salud con terceros bajo ninguna circunstancia.`,
          },
          {
            title: '2. Finalidad',
            body: `Los datos recopilados se utilizan exclusivamente para brindarte estadísticas personales dentro de la plataforma y para mejorar los algoritmos de análisis de ${PRODUCT}. Nunca serán vendidos, alquilados ni cedidos a anunciantes u otras empresas.`,
          },
          {
            title: '3. Seguridad',
            body: 'Toda la comunicación entre tu dispositivo y nuestros servidores está cifrada con TLS. Los datos sensibles en reposo están protegidos con controles de acceso estrictos. Solo vos podés ver tu historial, a menos que decidas compartirlo explícitamente con un familiar o profesional de la salud.',
          },
          {
            title: '4. Compartir con terceros',
            body: 'Si elegís generar un link de acceso para un familiar o médico, ese link tiene una duración limitada que vos controlás. Podés revocarlo en cualquier momento desde la sección "Compartir" de la app.',
          },
          {
            title: '5. Eliminación de datos',
            body: 'Podés solicitar la eliminación completa de tu cuenta y todos tus datos en cualquier momento escribiéndonos a contacto@cagliero.ar. La eliminación es permanente e irreversible.',
          },
          {
            title: '6. Limitación de responsabilidad',
            body: `${PRODUCT} es una herramienta de monitoreo personal y no constituye asesoramiento médico. Ante cualquier síntoma o duda sobre tu salud, consultá a un profesional médico. No somos responsables de decisiones tomadas en base a los datos de la plataforma.`,
          },
          {
            title: '7. Modificaciones',
            body: 'Podemos actualizar estos términos ocasionalmente. Te notificaremos dentro de la app ante cambios significativos. El uso continuado de la plataforma implica la aceptación de los términos vigentes.',
          },
          {
            title: '8. Contacto',
            body: 'Para consultas sobre privacidad o estos términos, escribinos a contacto@cagliero.ar.',
          },
        ].map(({ title, body }) => (
          <div key={title} style={{ marginBottom: 32 }}>
            <h2 style={{ fontSize: 16, fontWeight: 700, color: '#fff', marginBottom: 8 }}>{title}</h2>
            <p style={{ fontSize: 15, lineHeight: 1.6, color: 'rgba(255,255,255,0.65)' }}>{body}</p>
          </div>
        ))}

        <div style={{ borderTop: '1px solid rgba(255,255,255,0.08)', paddingTop: 24, marginTop: 8 }}>
          <Link to="/register" style={{ fontSize: 14, color: '#ff3b30', textDecoration: 'none', fontWeight: 600 }}>
            Volver al registro →
          </Link>
        </div>
      </div>
    </div>
  )
}
